/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GhUserProfileResponse } from '../../models/gh-user-profile-response';

export interface GetUserProfile$Params {
}

export function getUserProfile(http: HttpClient, rootUrl: string, params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<GhUserProfileResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserProfile.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GhUserProfileResponse>;
    })
  );
}

getUserProfile.PATH = '/api/me/profile';
